<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="lockStock">
    <div slot="header" class="modal-header">{{lockText}}</div>
    <p>确认要{{lockText}}该房间吗?</p>
  </Modal>
</template>

<script type="text/ecmascript-6">
  import { lockStock } from "api/house"

  export default {
    props:{
      n:{
        type:Number,
        default:0
      },
      lockType:{
        type:Number,
        default:0
      },
      stockFid:{
        type:String,
        default:''
      },
      subLockKey: {
        type:Number,
        default:0
      },
      projectFid: {
        type: String | Number,
        default: '',
      }
    },
    computed: {
      lockText() {
        return this.lockType === 0 ? '解锁' : '锁定'
      }
    },
    data () {
      return {
        show:false
      };
    },
    watch:{
      n(val){
        this.show = true;
      },
      subLockKey(val) {
        this.show = true
        // console.log(this.lockType)
      }
    },
    methods:{
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      lockStock() {
        const params = {
          stockFid: this.stockFid,
          lockOrUnLock: this.lockType,
          projectFid: this.projectFid,
        }
        lockStock(params).then( res => {
          this.changeLoading();
          this.$Message.success(`${this.lockText}成功`);
          this.show = false;
          this.$emit('refresh')
        }).catch(error => {
          this.changeLoading();
        })
      }
    }
  }
</script>
